export default
{
    props:
    {
        placeholder: ''
    },

    data()
    {
        return {
            email: ''
        }
    },

    watch:
    {
        email(email)
        {
            this.$emit('change', email)
        }
    },

    methods:
    {
        submit()
        {
            this.$emit('submit')
        }
    }
}
